import React, { useState } from "react";
import { Backdrop, Fade, TextField, Modal, Typography } from '@mui/material';
import { AiOutlinePlus } from "react-icons/ai";
import { addEcole } from "../../../../services/EcoleService";
import { withSnackbar } from "../../../../utils/SnackbarHOC";
import { AppButton } from "../../../../components/UI";

const paperStyle = {
  backgroundColor: '#fff',
  boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
  padding: '24px 32px',
  borderRadius: '16px',
  minWidth: '360px',
  maxWidth: '95vw',
  outline: 'none',
};

function EmployeurModal({ errors, setErrors, snackbarShowMessage, setReloadData, reloadData }) {
  const [modalState, setModalState] = useState({ open: false });
  const [newEcole, setNewEcole] = useState("");
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let temp = {};
    temp.newEcole = newEcole ? "" : "Le champ 'NOM DE DIPLÔME PRINCIPAL est obligatoire.";
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleOpen = () => setModalState({ open: true });
  const handleClose = () => setModalState({ open: false });

  const handleSubmit = () => {
    if (validate()) {
      setLoading(true);
      addEcole({ name: newEcole }).then((response) => {
        snackbarShowMessage("L'ecole a été ajoutée avec succès.", "success");
        setLoading(false);
        handleClose();
        setReloadData(!reloadData);
      }).catch((error) => {
        snackbarShowMessage("Erreur d'ajout de l'ecole.", "error", 4000);
        setLoading(false);
      });
    }
  };

  React.useEffect(() => {
    return () => setNewEcole("");
  }, []);

  const body = (
    <div style={paperStyle}>
      <div className="modal-header" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', marginBottom: '16px' }}>
        <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', fontFamily: "'Fira Sans', sans-serif" }}>
          Ajouter un diplôme principal
        </Typography>
      </div>
      <div className="modal-body">
        <label className="input-label" htmlFor="nomEcole">
          NOM DE DIPLÔME PRINCIPAL <span className="required-input">*</span>
        </label>
        <TextField
          id="nomEcole"
          value={newEcole}
          onChange={(e) => setNewEcole(e.target.value)}
          placeholder="Nom de le Diplôme(s)."
          margin="normal"
          variant="outlined"
          autoComplete="off"
          fullWidth
          {...(errors.newEcole && { error: true, label: errors.newEcole })}
        />
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', borderTop: '1px solid #f1f5f9', paddingTop: '16px', marginTop: '16px' }}>
        <AppButton variant="secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </AppButton>
        <AppButton variant="primary" onClick={handleSubmit} loading={loading}>
          Sauvegarder
        </AppButton>
      </div>
    </div>
  );

  return (
    <>
      <button className="btn btn-sm btn-link float-right" style={{ textDecoration: "none" }} onClick={handleOpen}>
        <AiOutlinePlus style={{ fontWeight: 500, marginBottom: "0.2em" }} />
        Ajouter
      </button>
      <Modal
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        open={modalState.open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={modalState.open}>{body}</Fade>
      </Modal>
    </>
  );
}

export default withSnackbar(EmployeurModal);
